import styled from 'styled-components';
import { PageTheme } from 'config/theme';

interface IProps {
  isSecondary?: boolean;
  theme? : PageTheme
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const Text = styled.p<IProps>`
  font-size: 14px;
  color: #333333;
  margin-bottom: 10px;

  ${({ isSecondary, theme }) =>
    isSecondary &&
    `
      color: ${theme.textSecondary} !important;
      font-size: 13px;
      font-style: italic;
      margin-bottom: 14px;
    `}
`;

export const Title = styled.h3<IProps>`
  font-weight: bold;
  margin: 0;
  color: #333333;

  ${({ isSecondary, theme }) =>
    isSecondary &&
    `
      color: ${theme.textSecondary} !important;
      font-size: 13px;
      font-style: italic;
      margin-bottom: 10px;
    `}
`;

export const OL = styled.ol<IProps>`
  color: #333333;

  ${({ isSecondary, theme }) =>
    isSecondary &&
    `
      color: ${theme.textSecondary} !important;
      font-style: italic;

      li {
        font-size: 13px;
      }
    `}
`;

export const UL = styled.ul<IProps>`
  margin-left: 15px;
  color: #333333;

  ${({ isSecondary, theme }) =>
    isSecondary &&
    `
      color: ${theme.textSecondary} !important;
      font-style: italic;

      li {
        font-size: 13px;
      }
    `}
`;

export const LI = styled.li``;
